<template lang="pug">
.ui-tags-input(
  @click="focusInput()"
  :class="classes"
)
  UiTag(
    v-for="(tag, index) in modelValue"
    @close="deleteTag(index)"
    @click.stop
  ) {{ tag }}
  input.ui-tags-input__input(
    ref="input"
    v-model="input"
    @keydown.enter="createTag()"
    @focus="onFocus()"
    @blur="onBlur()"
    :placeholder="placeholder"
  )
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  emits: ["update:modelValue"],

  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      focus: false,
      input: "",
    };
  },

  computed: {
    classes() {
      return {
        "ui-tags-input--focused": this.focus,
      };
    },
  },

  methods: {
    createTag() {
      if (!this.input) {
        return;
      }
      this.$emit("update:modelValue", [...this.modelValue, this.input]);
      this.input = "";
    },

    deleteTag(index) {
      const newValue = [...this.modelValue];
      newValue.splice(index, 1);
      this.$emit("update:modelValue", newValue);
    },

    focusInput() {
      this.$refs.input.focus();
    },

    onFocus() {
      this.focus = true;
    },

    onBlur() {
      this.createTag();
      this.focus = false;
    },
  },
});
</script>

<style lang="scss" scoped>
.ui-tags-input {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  min-height: 42px;
  overflow: hidden;
  border: 1px solid var(--bb-input-border);
  font-size: 1rem;
  padding: 0.35rem 0.5rem;
  align-items: center;
  background: var(--bb-app-bg-main);
  border-radius: 0.75rem;

  &__input {
    min-width: 100px;
    flex-grow: 1;
    flex-shrink: 1;
    border: 0px solid transparent;

    &:focus {
      outline: none;
    }
  }

  &--focused {
    border-color: var(--bb-primary);
  }
}
</style>
